/* eslint-disable */
import { FormContextType, getUiOptions, RJSFSchema, StrictRJSFSchema } from '@rjsf/utils';
import React from 'react';

function AnyOfField<T = any, S extends StrictRJSFSchema = RJSFSchema, F extends FormContextType = any>({
	id,
	title,
	uiSchema,
}: any) {
	const uiOptions = getUiOptions<T, S, F>(uiSchema);

	return <div id={id} data-role="AnyOfField" />;
}

export { AnyOfField };
